module.exports = __webpack_public_path__ + "img/9788982738630.2eb22e62.jpg";